import React, { useEffect, useState, useContext } from "react";
import './Abountus.css'
import logo from '../../Assest/LogoSingefin.png'
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import { NavLink } from "react-router-dom";
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";

function AbountUs() {

    const urlGetAbountUs = urlApiServer + "abountuses?populate=*"
    const urlGetTeam = urlApiServer + "teams?populate=*"


    const [data, setData] = useState([]);
    const [dataTeam, setDataTeam] = useState([]);
    const { infoUser } = useContext(LoginContext)

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetAbountUs, requestOptions)
                    .then(response => response.json())
                    .then(AbountUsResponse => {
                        console.log('info sobre mi: ', AbountUsResponse.data);
                        setData(AbountUsResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }
        })();
    }, [urlGetAbountUs]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetTeam, requestOptions)
                    .then(response => response.json())
                    .then(teamResponse => {
                        console.log('imagenes del equipo: ', teamResponse.data);
                        setDataTeam(teamResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }
        })();
    }, [urlGetTeam]);

    // const images = data.length > 0 && data[0].equipo ? data[0].equipo : [];


    return (
        <div className="containerAbountUs">
            <div className="containerBannerAbountUs">
                <div className="bannerAbountUs">
                    <div
                        style={{
                            backgroundImage: data.length > 0 && data[0].imagen_portada_sobre_nosotros?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_sobre_nosotros.url})`
                                : "url('../../Assest/temporary/bannerAbountUs.png')", // Imagen de respaldo
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}

                        className="imageBannerAbountUs"
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerAbountUs">
                                {data[0].titulo_portada_sobre_nosotros ? data[0].titulo_portada_sobre_nosotros : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                    {infoUser.isLoged === true ? (
                        <div className="ContainerButton">
                            <div className="ButtonBanner" onClick={loggedInUser}>
                                <p className="titleButtonBanner">VINCULATE</p>
                            </div>
                        </div>
                    ) : (
                        <div className="ContainerButton">
                            <NavLink className="navLinks navLinkLegal" to="/Vinculacion">
                                <div className="ButtonBanner">
                                    <p className="titleButtonBanner">VINCULATE</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>
            <div className="containerInfoAbountUsSection">
                {data.length > 0 && data[0].texto_seccion_sobre_nosotros ? (
                    data[0].texto_seccion_sobre_nosotros.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoAbountUsSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textAbountUsSection">
                                                {child.text}
                                            </p>
                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textAbountUsSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textAbountUsSection">...</p>
                )}
            </div>
            <div className="containerMission">
                <div className="containerImageMission">
                    <img
                        src={
                            data.length > 0 && data[0].imagen_mision?.url
                                ? urlApiServerImage + data[0].imagen_mision.url
                                : "fallback-image.jpg" // Imagen de respaldo
                        }
                        alt='Mision'
                        className="imageMission"
                    />
                </div>
                <div className="containerTextMision">
                    <p className="titleMissionandvision">Mision</p>
                    <p className="textMissionandvision">{data.length > 0 && data[0].texto_mision ? data[0].texto_mision : "..."}</p>
                </div>
            </div>
            <div className="containerVision">
                <div className="containerTextVision">
                    <p className="titleMissionandvision">Vision</p>
                    <p className="textMissionandvision">{data.length > 0 && data[0].texto_vision ? data[0].texto_vision : "..."}</p>
                </div>
                <div className="containerImageVision">
                    <img
                        src={
                            data.length > 0 && data[0].imagen_vision?.url
                                ? urlApiServerImage + data[0].imagen_vision.url
                                : "fallback-image.jpg" // Imagen de respaldo
                        }
                        alt='Vision'
                        className="imageVision"
                    />
                </div>
            </div>
            <div className="containerHistorie">
                <p className="titleHistorie">Historia</p>
                <div className="cardMissionSection">
                    <p className="textHistorie">{data.length > 0 && data[0].texto_historia ? data[0].texto_historia : "..."}</p>
                </div>
            </div>
            <div className="containerGAllery">
                <p className="tittleTeam">Equipo</p>
                <div className="gallery-container">
                    {dataTeam && Array.isArray(dataTeam) ? (
                        dataTeam
                            .sort((a, b) => parseInt(a.posicion) - parseInt(b.posicion)) // Ordena por posición
                            .map((team, index) => (
                                <div key={team.id} className={`gallery-item ${index === 0 ? 'gallery-item-large' : ''}`}>
                                    {team.foto && (
                                        <img
                                            src={urlApiServerImage + team.foto.url}
                                            alt={`Gallery ${index + 1}`}
                                        />
                                    )}
                                    <div className="containerTextTeamGallery">
                                        <p className="TextImageGallery">Nombre: {team.nombre}</p>
                                        <p className="TextImageGallery">Cargo: {team.cargo}</p>
                                        {team.zona && <p className="TextImageGallery">Zona: {team.zona}</p>}
                                    </div>
                                </div>
                            ))
                    ) : (
                        <p>Cargando datos del equipo...</p> // Mensaje de carga si `dataTeam` no está listo
                    )}
                </div>
            </div>
        </div>
    )
}

export default AbountUs
